/* global axios */
import { attentionState, attentionFor } from './state';
import { conversationRequestScope } from './requestScope';

export async function personalReceipt(context, { id, source }, mode) {
  // Automatic legacy callbacks never represent an acknowledgment. The global
  // visible-message heuristic is the only automatic personal read writer.
  if (source === 'visible') return;
  const valid = conversationRequestScope(context);
  const account = context.rootGetters?.getCurrentAccountId;
  const actor = context.rootGetters?.getCurrentUser?.id;
  const snapshot = attentionState.snapshot;
  const item = attentionFor(id);
  try {
    if (!valid() || snapshot?.account_id !== account || snapshot?.actor_id !== actor || !item?.receipt_token) {
      throw new Error('Wait for this conversation’s attention state to load, then try again.');
    }
    // Use the token that produced the displayed row, never a later fetch.
    await axios.post(`/api/v1/accounts/${account}/attention/acknowledge`, { mode, receipt_token: item.receipt_token });
    if (valid()) window.dispatchEvent(new CustomEvent('attention:changed'));
  } catch (error) {
    if (valid()) window.dispatchEvent(new CustomEvent('attention:receipt-error', { detail: {
      actor_id: actor, account_id: account, conversation_id: Number(id),
      message: 'Personal acknowledgment was not saved. Refresh attention and try again; waiting work remains.'
    } }));
    throw error;
  }
}
